import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, loadAdminToken, setAdminToken } from "@/lib/api";

const Ctx = createContext({ token: null, isAdmin: false, signIn: async () => {}, signOut: () => {} });

export function AdminAuthProvider({ children }) {
  const [token, setToken] = useState(null);

  useEffect(() => {
    const t = loadAdminToken();
    if (t) setToken(t);
  }, []);

  const signIn = useCallback(async (email, password) => {
    const { data } = await api.post("/admin/login", { email, password });
    setAdminToken(data.token);
    setToken(data.token);
    return data;
  }, []);

  const signOut = useCallback(() => {
    setAdminToken(null);
    setToken(null);
  }, []);

  const value = useMemo(() => ({ token, isAdmin: !!token, signIn, signOut }), [token, signIn, signOut]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useAdminAuth() { return useContext(Ctx); }
